import { useEffect } from "react"
import { useTranslation } from "react-i18next"
import { useModal } from "customerAttachments/contexts/ModalProvider"
import { setGlobalErrorHandler } from "customerAttachments/utils/globalErrorHandler"

const AppModalInitializer = () => {
  const { openModal } = useModal()
  const { t } = useTranslation(["sales", "label"])

  useEffect(() => {
    setGlobalErrorHandler(() => {
      openModal({
        title: t("customer_attachments.message.system_is_busy"),
        content: t("customer_attachments.message.try_again_later"),
        showCancel: false,
        confirmButtonText: t("customer_attachments.message.try_again"),
      })
    })
  }, [openModal, t])

  return null
}

export default AppModalInitializer
